<template>
<Dialog header="İşaretleme Raporu" 
v-model:visible="show_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
>
<h4 class="text-purple-500">{{selectedsuppliers.length}} tedarikçi seçildi 
<span class="ml-2" v-if="submitting"><ProgressSpinner style="width:18px;height:18px" strokeWidth="2"  /></span>
</h4>


<Button label="Başlamak için tıklayın"  
@click="startDownload" 
class=" p-button-primary p-button-outlined  p-button-sm" 
v-if="!submitting"/>

<template v-if="submitting">
<ProgressBar :value="percentage"></ProgressBar>
</template>

<template v-if="ended">
<h4 class="text-green-500">{{$store.state.languages.lang_phrases.tamamlandi}}</h4>
</template>



<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" />
</template>


</Dialog>
</template>

<script>
export default {

  name: 'SupplierMarkingsDownloadModal',
  props:["selectedsuppliers"],
  data () {
    return {
    	show_modal:false,
    	submitting:false,
    	percentage:0,
    	steps:0,
    	ended:false,
    }
  },
  methods:{
  	async startDownload()
  	{
  		console.log("startDownload")
  		console.log(this.selectedsuppliers)
  		this.submitting = true
  		this.ended = false
  		this.steps = parseFloat((100/this.selectedsuppliers.length).toFixed(2))
  		for(let item of this.selectedsuppliers)
  		{
  			let result = await this.getSupplierMarkingsData(item.uuid)  			
	  		this.percentage += this.steps
	  		if(this.percentage>100)
	  		{
	  			this.percentage = 100
	  		}
  		}
  		setTimeout(()=>{
  			this.submitting = false
  			this.ended = true
  		},1000)
  		
  	},
  	async getSupplierMarkingsData(uuid)
  	{
  		let data = await this.generalApiGetWithoutLoader("audit/get_flow_summary_data/"+uuid)
  		await this.$store.dispatch('evaluation/setEvaluation',data.flowsupplier) 
		if(data.quizresult && data.quizresult.questionlist)
		{
			await this.$store.dispatch('evaluation/setNullreasons',data.quizresult.questionlist.nullreasons)        
		}
		if(data.flowsupplier.flow.type=="self_evaluation" || data.flowsupplier.flow.type=="verification")
		{
			
			await this.downloadSelfEvalMarkingReport(data) 
		}
		if(data.flowsupplier.flow.type=="audit")
		{        
			await this.downloadAuditMarkingReport(data) 
		}
		return "done"
  	},
  	showModal(action)
  	{
  		this.selected_customattribute = null
  		this.selected_value = null
  		this.show_modal = true
  	},
  	hideModal()
  	{
  		this.$emit("closemodal")
  		this.show_modal = false
  		this.submitting = false
  		this.ended = false
  	},
  }
}
</script>

<style lang="css" scoped>
</style>